module.exports = __webpack_public_path__ + "static/media/logo-metecno-specialist-01.4e0d64c2.jpg";